import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestfulApiService } from '../restful-api.service';
import {
  SearchSuggestionsPayload,
  SearchSuggestionsResponse,
  SearchTotalsPayload,
  SearchTotalsResponse,
  SearchResultsPayload,
  SearchResultsResponse,
} from '../../models/search-suggestions.model';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private readonly suggestionsEndpoint = '/v1/home/search-suggestions';
  private readonly totalsEndpoint = '/v1/home/search-suggestions/totals';
  private readonly resultsEndpoint = '/v1/home/search-suggestions/catalog';

  constructor(private restfulApiService: RestfulApiService) {}

  /**
   * Get search suggestions based on search text
   * @param payload - SearchSuggestionsPayload object containing search text and language code
   * @returns Observable<SearchSuggestionsResponse>
   */
  getSearchSuggestions(
    payload: SearchSuggestionsPayload
  ): Observable<SearchSuggestionsResponse> {
    return this.restfulApiService.post(
      this.suggestionsEndpoint,
      payload
    ) as Observable<SearchSuggestionsResponse>;
  }

  /**
   * Get search totals for projects, portfolios, and organisations
   * @param payload - SearchTotalsPayload object containing search text and language code
   * @returns Observable<SearchTotalsResponse>
   */
  getSearchTotals(
    payload: SearchTotalsPayload
  ): Observable<SearchTotalsResponse> {
    return this.restfulApiService.post(
      this.totalsEndpoint,
      payload
    ) as Observable<SearchTotalsResponse>;
  }

  /**
   * Get search results with full catalog data
   * @param payload - SearchResultsPayload object containing search text, language code, pagination, and totals
   * @returns Observable<SearchResultsResponse>
   */
  getSearchResults(
    payload: SearchResultsPayload
  ): Observable<SearchResultsResponse> {
    return this.restfulApiService.post(
      this.resultsEndpoint,
      payload
    ) as Observable<SearchResultsResponse>;
  }
}
